import React, { ForwardRefRenderFunction, ReactNode, RefObject } from 'react';
import Link from '../../Link/viewer/Link';
import { TestIds, ElementType } from '../constants';
import { IFocusPropsSDKActions } from '../../../core/corvid/props-factories/focusPropsSDKFactory';
import { ISiteButtonImperativeActions } from '../SiteButton.types';
import { activateBySpaceOrEnterButton } from '../../../core/commons/a11y';
import { SkinButtonProps } from './skinComps/SkinButton';

export type SiteButtonContentCompProps = {
  linkProps: SkinButtonProps['linkProps'];
  elementType: SkinButtonProps['elementType'];
  className: string;
  children: ReactNode;
  autoFocus?: boolean;
} & IFocusPropsSDKActions;

const SiteButtonContent: ForwardRefRenderFunction<
  ISiteButtonImperativeActions,
  SiteButtonContentCompProps
> = (
  { elementType, linkProps, className, children, autoFocus, onBlur, onFocus },
  ref,
) => {
  const buttonRef = React.useRef<
    HTMLAnchorElement | HTMLDivElement | HTMLButtonElement
  >(null);

  React.useImperativeHandle(ref, () => ({
    focus: () => buttonRef.current?.focus(),
    blur: () => buttonRef.current?.blur(),
  }));

  switch (elementType) {
    case ElementType.Link:
      return (
        <Link
          {...(linkProps || {})}
          className={className}
          ref={buttonRef as RefObject<HTMLAnchorElement | HTMLDivElement>}
          onFocusCapture={onFocus}
          onBlurCapture={onBlur}
        >
          {children}
        </Link>
      );
    case ElementType.Button:
      return (
        <button
          ref={buttonRef as RefObject<HTMLButtonElement>}
          data-testid={TestIds.buttonElement}
          className={className}
          autoFocus={autoFocus}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={activateBySpaceOrEnterButton}
        >
          {children}
        </button>
      );
    default:
      return null;
  }
};

export default React.forwardRef(SiteButtonContent);
